<template>
    <div>
        <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
            <CCol sm="12" @click="GoToSetting()">
                <img src="../assets/img/arrow-left.png" style="max-width:18px;" class="float-left"/>
                <h3 class="custom-18px-500 font-color-171717" style="padding-left: 25px;">Back</h3>
            </CCol>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <CRow class="m-2">
                    <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                        <div :class="{'grey-background': activeButton === button.value, 'font-color-98A2B3': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                            {{ button.label }}
                        </div>
                    </CCol>
    
                </CRow>
            </CCard>
            <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div v-if="activeButton === 'detail'">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Company Details</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="3">
                                <h3 class="custom-14px-500 font-color-171717">Company Logo</h3>
                                <img :src="company.LogoPath" style="max-width:150px" />
                            </CCol>
                            <CCol sm="9">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-14px-500 font-color-171717">Company Name</h3>
                                        <CInput type="text" v-model="company.FullName" disabled/>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Company Short Name</h3>
                                        <CInput type="text" v-model="company.ShortName" disabled/>
                                    </CCol>
                                    <CCol sm="5">
                                        <h3 class="custom-14px-500 font-color-171717">Company Registration Number</h3>
                                        <CInput type="text" v-model="company.RegistrationNumber" disabled/>
                                    </CCol>
                                    <CCol sm="3">
                                        <h3 class="custom-14px-500 font-color-171717">Company Type</h3>
                                        <CInput type="text" v-model="company.CompanyTypeName" disabled/>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Industry</h3>
                                        <CInput type="text" v-model="company.IndustryType" disabled/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Email</h3>
                                <CInput type="text" v-model="Email" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                <CInput type="text" v-model="PhoneNumber" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Street Address</h3>
                                <CInput type="text" v-model="company.Address" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Fax</h3>
                                <CInput type="text" v-model="company.Fax" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">State</h3>
                                <CInput type="text" v-model="company.State" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">City</h3>
                                <CInput type="text" v-model="company.City" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Postal Code</h3>
                                <CInput type="text" v-model="company.Postcode" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Country</h3>
                                <CInput type="text" v-model="company.Country" disabled/>
                            </CCol>
    
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddCompany()">
                                Edit</CButton>
                        </div>
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'bank'">
                    <div class="p-2">
                        <h3 class="custom-18px-500 font-color-171717">Bank & Other Account Details</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Bank Name</h3>
                                <CInput type="text" v-model="detailBank.BankName" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Bank Account Number</h3>
                                <CInput type="text" v-model="detailBank.BankAccountNumber" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">BBMB Autopay Code</h3>
                                <CInput type="text" v-model="detailBank.BbmbAutopayCode" disabled/>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">EPF Account Number</h3>
                                <CInput type="text" v-model="detailBank.EpfAccountNumber" disabled />
                            </CCol>
    
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Socso Account Number</h3>
                                <CInput type="text" v-model="detailBank.SocsoAccountNumber" disabled />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Income Tax Number</h3>
                                <CInput type="text" v-model="detailBank.IncomeTaxNumber" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Employer Number</h3>
                                <CInput type="text" v-model="detailBank.EmployerNumber" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">LHDN Branch</h3>
                                <CInput type="text" v-model="detailBank.LhdnBranch" disabled/>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Originator ID</h3>
                                <CInput type="text" v-model="detailBank.OriginatorId" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Zakat Number</h3>
                                <CInput type="text" v-model="detailBank.ZakatNumber" disabled/>
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">C-Number</h3>
                                <CInput type="text" v-model="detailBank.CNumber" disabled/>
                            </CCol>
    
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="openAddBank">
                                Edit</CButton>
                        </div>
    
                    </div>
                </div>
    
                <div v-if="activeButton === 'subsidary'">
                    <div class="p-2 text-right">
                        <CButton class="btn-border-blue font-color-0B63F6" @click="openAddSubs"><img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1" />Add Now</CButton>
                        <CButton class="btn-border-blue font-color-0B63F6 ml-2" @click="openExistCompany"><img src="../assets/img/form_link.png" style="max-width:20px" class="mr-1" />Link to Existing Company</CButton>
                    </div>
    
                    <div>
                        <table class="table table-responsive-sm" v-if="Array.isArray(filteredsubTableData) && filteredsubTableData.length > 0">
                            <thead class="custom-table">
                                <th>No</th>
                                <th>Subsidary Company</th>
                                <th>Subsidary Registration Number</th>
                                <th>Industry Type</th>
                                <th>Total Staff</th>
                                <th>Action</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in filteredsubTableData" :key="item.id">
                                    <!-- <td>
                                                    <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                                </td> -->
                                    <td>{{ index+1 }}</td>
                                    <td>
                                        <label class="custom-14px-500">{{ item.FullName }}</label>
                                    </td>
                                    <td>
                                        <label class="custom-14px-500">
                                                                                                                                {{ item.RegistrationNumber }}
                                                                                                                            </label>
                                    </td>
                                    <td>
                                        <label class="custom-14px-500">{{ item.IndustryType }}</label>
                                    </td>
                                    <td>
                                        <label class="custom-14px-500">{{ item.TotalStaff }}</label>
                                    </td>
                                    <td>
                                        <div class="d-flex">
                                            <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openSubDetail(item.SubsidaryId)" class="ml-2" />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
    
                        <div v-else class="no-data-message">
    
                            <div class="full-height-container">
                                <div class="no-data-message">
                                    <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                    <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                    <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                </div>
                            </div>
                        </div>
                    </div>
    
    
    
    
                </div>
    
            </CCard>
        </CCol>
    
        <div v-if="OpenAddCompany" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Edit</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddCompany" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <div class="text-center p-1">
                                    <CCard>
                                        <div class="text-center">
                                            <br /><br />
                                            <img :src="company.LogoPath" style="max-width:150px" v-if="filePreview == null" />
    
                                            <img :src="filePreview" style="max-width: 100px; cursor: pointer;" @click="triggerFileInput" />
                                            <input type="file" ref="fileInput" @change="onFileChange" style="display: none;" />
                                            <p class="font-color-0B63F6" @click="triggerFileInput">Click to upload</p>
                                            <p class="font-color-98A2B3">SVG, PNG, JPG, or GIF (max. 800x400px)</p>
    
                                            <!-- Display the file name if an image is not uploaded -->
                                            <p v-if="fileName" class="mt-2 mb-5">{{ fileName }}</p>
                                        </div>
    
    
                                    </CCard>
                                </div>
                            </CCol>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-14px-500 font-color-171717">Company Name</h3>
                                        <CInput type="text" v-model="company.FullName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Company Short Name</h3>
                                        <CInput type="text" v-model="company.ShortName" />
                                    </CCol>
                                    <CCol sm="5">
                                        <h3 class="custom-14px-500 font-color-171717">Company Registration Number</h3>
                                        <CInput type="text" v-model="company.RegistrationNumber" />
                                    </CCol>
                                    <CCol sm="3">
                                        <h3 class="custom-14px-500 font-color-171717">Company Type</h3>
                                        <v-select v-model="SelectedType" :options="companyType" label="Name"></v-select>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Industry</h3>
                                        <v-select v-model="SelectedIndustryType" :options="industryOptions" label="Name"></v-select>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Email</h3>
                                <CInput type="text" v-model="company.Email" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                <CInput type="text" v-model="company.PhoneNumber" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Fax</h3>
                                <CInput type="text" v-model="company.Fax" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Street Address</h3>
                                <CInput type="text" v-model="company.Address" />
                            </CCol>
    
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Country</h3>
                                <v-select v-model="SelectedCountry" :options="countryOptions" label="CountryName" @input="GetListState(SelectedCountry.Id)"></v-select>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">State</h3>
                                <v-select v-model="SelectedState" :options="stateOptions" label="Name" @input="GetListCity(SelectedState.Id)"></v-select>
                            </CCol>
                            <CCol sm="6" class="mt-2">
                                <h3 class="custom-14px-500 font-color-171717">City</h3>
                                <v-select v-model="SelectedCity" :options="cityOptions" label="Name"></v-select>
                            </CCol>
    
                            <CCol sm="6" class="mt-3">
                                <h3 class="custom-14px-500 font-color-171717">Postal Code</h3>
                                <CInput type="text" v-model="company.Postcode" />
                            </CCol>
    
    
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitCompany">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
        <div v-if="OpenAddBank" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Edit</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupeAddBank" /></CCol>
                </CRow>
    
                <div class="p-2">
                    <CRow>
                        <CCol sm="12">
                            <h3 class="custom-14px-500 font-color-171717">Bank Name</h3>
                            <v-select v-model="SelectedBank" :options="bank" label="Name"></v-select>
                        </CCol>
                        <CCol sm="6" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">Bank Account Number</h3>
                            <CInput type="text" v-model="detailBank.BankAccountNumber" />
                        </CCol>
    
                        <CCol sm="6" class="mt-2">
                            <h3 class="custom-14px-500 font-color-171717">BBMB Autopay Code</h3>
                            <CInput type="text" v-model="detailBank.BbmbAutopayCode" />
                        </CCol>
                        <CCol sm="12">
                            <hr class="custom-hr" />
                        </CCol>
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">EPF Account Number</h3>
                            <CInput type="text" v-model="detailBank.EpfAccountNumber" />
                        </CCol>
    
    
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">Socso Account Number</h3>
                            <CInput type="text" v-model="detailBank.SocsoAccountNumber" />
                        </CCol>
    
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">Income Tax Number</h3>
                            <CInput type="text" v-model="detailBank.IncomeTaxNumber" />
                        </CCol>
    
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">Employer Number</h3>
                            <CInput type="text" v-model="detailBank.EmployerNumber" />
                        </CCol>
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">LHDN Branch</h3>
                            <CInput type="text" v-model="detailBank.LhdnBranch" />
                        </CCol>
    
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">Originator ID</h3>
                            <CInput type="text" v-model="detailBank.OriginatorId" />
                        </CCol>
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">Zakat Number</h3>
                            <CInput type="text" v-model="detailBank.ZakatNumber" />
                        </CCol>
                        <CCol sm="6">
                            <h3 class="custom-14px-500 font-color-171717">C-Number</h3>
                            <CInput type="text" v-model="detailBank.CNumber" />
                        </CCol>
    
                    </CRow>
                    <div class="text-right">
                        <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitBank">
                            Save Changes</CButton>
                    </div>
    
    
                </div>
            </div>
        </div>
    
        <div v-if="OpenAddSubsidary" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Add Company Subsidary</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupAddSubs" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
    
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-14px-500 font-color-171717">Company Name</h3>
                                        <CInput type="text" v-model="FullNameSub" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Company Short Name</h3>
                                        <CInput type="text" v-model="ShortNameSub" />
                                    </CCol>
                                    <CCol sm="5">
                                        <h3 class="custom-14px-500 font-color-171717">Company Registration Number</h3>
                                        <CInput type="text" v-model="RegistrationNumberSub" />
                                    </CCol>
                                    <CCol sm="3">
                                        <h3 class="custom-14px-500 font-color-171717">Company Type</h3>
                                        <v-select v-model="SelectedTypeSub" :options="companyType" label="Name"></v-select>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Industry</h3>
                                        <v-select v-model="SelectedIndustryTypeSub" :options="industryOptions" label="Name"></v-select>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Email</h3>
                                <CInput type="text" v-model="EmailSub" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                <CInput type="text" v-model="PhoneNumberSub" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Street Address</h3>
                                <CInput type="text" v-model="AddressSubs" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Fax</h3>
                                <CInput type="text" v-model="FaxSub" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Country</h3>
                                <v-select v-model="SelectedCountrySub" :options="countryOptions" label="CountryName" @input="GetListStateSub(SelectedCountrySub.Id)"></v-select>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">State</h3>
                                <v-select v-model="SelectedStateSub" :options="stateOptions" label="Name" @input="GetListCity(SelectedStateSub.Id)"></v-select>
                            </CCol>
                            <CCol sm="6" class="mt-2">
                                <h3 class="custom-14px-500 font-color-171717">City</h3>
                                <v-select v-model="SelectedCitySub" :options="cityOptions" label="Name"></v-select>
                            </CCol>
    
                            <CCol sm="6" class="mt-3">
                                <h3 class="custom-14px-500 font-color-171717">Postal Code</h3>
                                <CInput type="text" v-model="PostcodeSub" />
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Total Staff</h3>
                                <CInput type="text" v-model="totalStaff" />
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="SubmitSubsidary">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
        <div v-if="OpenLinkExistCompany" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Link to Existing Company</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupExistCompany" /></CCol>
                </CRow>
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Username</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Password</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="1" class="mt-2">
                                <img src="../assets/img/icondanger.png" width="20px" />
                            </CCol>
                            <CCol sm="11" class="mt-2">
                                <label class="text-danger">Please insert your username and password account from your subsidary company</label>
                            </CCol>
    
                        </CRow>
                        <CCol sm="12" class="mt-3">
                            <CRow>
                                <CCol sm="6">
                                    <CButton class="custom-grey-radius font-color-171717" @click="closePopup" block>Cancel</CButton>
                                </CCol>
                                <CCol sm="6">
                                    <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half" block>
                                        Grant Access</CButton>
                                </CCol>
                            </CRow>
    
                        </CCol>
    
                    </div>
                </CCol>
            </div>
        </div>
    
        <div v-if="isPopupSuccess" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                    <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                        Your data has been submitted successfully.
                    </h3>
                    <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
            </div>
        </div>
    
        <div v-if="OpenUpdateSubsidary" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="10">
                        <h3 class="custom-24px-600 font-color-171717 text-left">Update Company Subsidary</h3>
                    </CCol>
                    <CCol sm="2" class="text-right"><img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupUpdateSubs" /></CCol>
                </CRow>
    
                <CCol sm="12" class="p-0">
                    <div class="p-2">
                        <CRow>
    
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="8">
                                        <h3 class="custom-14px-500 font-color-171717">Company Name</h3>
                                        <CInput type="text" v-model="subdetail.FullName" />
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Company Short Name</h3>
                                        <CInput type="text" v-model="subdetail.ShortName" />
                                    </CCol>
                                    <CCol sm="5">
                                        <h3 class="custom-14px-500 font-color-171717">Company Registration Number</h3>
                                        <CInput type="text" v-model="subdetail.RegistrationNumber" />
                                    </CCol>
                                    <CCol sm="3">
                                        <h3 class="custom-14px-500 font-color-171717">Company Type</h3>
                                        <v-select v-model="SelectedTypeSub" :options="companyType" label="Name"></v-select>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-14px-500 font-color-171717">Industry</h3>
                                        <v-select v-model="SelectedIndustryTypeSub" :options="industryOptions" label="Name"></v-select>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Email</h3>
                                <CInput type="text" v-model="subdetail.Email" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Phone Number</h3>
                                <CInput type="text" v-model="subdetail.PhoneNumber" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Street Address</h3>
                                <CInput type="text" v-model="subdetail.Address" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Company Fax</h3>
                                <CInput type="text" v-model="subdetail.Fax" />
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">Country</h3>
                                <v-select v-model="SelectedCountrySub" :options="countryOptions" label="CountryName" @input="GetListStateSub(SelectedCountrySub.Id)"></v-select>
                            </CCol>
    
                            <CCol sm="6">
                                <h3 class="custom-14px-500 font-color-171717">State</h3>
                                <v-select v-model="SelectedStateSub" :options="stateOptions" label="Name" @input="GetListCitySub(SelectedStateSub.Id)"></v-select>
                            </CCol>
                            <CCol sm="6" class="mt-2">
                                <h3 class="custom-14px-500 font-color-171717">City</h3>
                                <v-select v-model="SelectedCitySubsidary" :options="cityOptionsSub" label="Name"></v-select>
                            </CCol>
    
                            <CCol sm="6" class="mt-3">
                                <h3 class="custom-14px-500 font-color-171717">Postal Code</h3>
                                <CInput type="text" v-model="subdetail.Postcode" />
                            </CCol>
                            <CCol sm="12">
                                <h3 class="custom-14px-500 font-color-171717">Total Staff</h3>
                                <CInput type="text" v-model="subdetail.TotalStaff" />
                            </CCol>
                        </CRow>
                        <div class="text-right">
                            <CButton class="p-2 text-center bg-0B63F6 text-white border-radius-half custom-button-padding" @click="UpdateSubsidary">
                                Save Changes</CButton>
                        </div>
                        <br />
    
                    </div>
                </CCol>
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'detail', // Default active button
            buttons: [
                { value: 'detail', label: 'Company Details', activeIcon: 'announce-white.png', inactiveIcon: 'announce-black.png' },
                { value: 'bank', label: 'Bank & Other Account Details', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
                { value: 'subsidary', label: 'Company Subsidary', activeIcon: 'unread-white.png', inactiveIcon: 'unread-black.png' },
            ],

            options: {
                perPage: 5,
                pagination: true,
                searchable: true
            },

            OpenAddCompany: false,
            OpenAddSubsidary: false,
            OpenLinkExistCompany: false,
            isPopupSuccess: false,

            user: {},
            //company
            company: {},
            FullName: "",
            ShortName: "",
            RegistrationNumber: "",
            SelectedType: {},
            SelectedIndustryType: {},
            Email: "",
            PhoneNumber: "",
            Address: "",
            Fax: "",
            SelectedState: {},
            SelectedCity: {},
            Postcode: "",
            SelectedCountry: {},


            countryOptions: [],
            companyType: [],
            industryOptions: [],
            cityOptions: [],
            stateOptions: [],

            filePath: '',
            filePreview: null, // To hold the file preview URL
            fileName: null, // To hold the file name if not an image

            //bank
            OpenAddBank: false,
            detailBank: {},
            bank: [],
            SelectedBank: {},

            //subsidary
            FullNameSub: "",
            ShortNameSub: "",
            PhoneNumberSub: "",
            RegistrationNumberSub: "",
            PostcodeSub: "",
            AddressSubs: "",
            EmailSub: "",
            FaxSub: "",
            totalStaff: "",
            SelectedStateSub: {},
            SelectedCitySub: {},
            SelectedCountrySub: {},
            SelectedTypeSub: {},
            SelectedIndustryTypeSub: {},
            sub: [],
            filteredsubTableData: [],
            OpenUpdateSubsidary: false,
            subdetail: {},
            cityOptionsSub: [],
            SelectedCitySubsidary: {},

            newCompany: {
                FullName: '',
                ShortName: '',
                RegistrationNumber: '',
                Email: '',
                PhoneNumber: '',
                Fax: '',
                Address: '',
                Postcode: '',
            },
            updateCompany: {
                FullName: '',
                ShortName: '',
                RegistrationNumber: '',
                Email: '',
                PhoneNumber: '',
                Fax: '',
                Address: '',
                Postcode: '',
            },






        }





    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                await this.GetListIndustryType();
                await this.GetCompanyDetails();
                await this.GetCountry();
                await this.GetListState();
                //this.GetListCity(this.SelectedState ? this.SelectedState.Id : null);
                await this.GetListCompanyType();
                await this.GetCompanyDetailsByInfo();

                await this.GetCompanyBankDetails();
                await this.GetCompanyBankDetailsByInfo();
                await this.GetListBank();

                if (this.company.Country) {
                    await this.GetListState();

                    if (this.company.State) {
                        await this.GetListCity(this.SelectedState.Id);
                    }

                }

                if (this.subdetail.Country) {
                    await this.GetListStateSub();
                    if (this.subdetail.State) {
                        console.log("test" + this.SelectedStateSub.Id);
                        await this.GetListCitySub(this.SelectedStateSub.Id);
                    }
                }


                await this.GetAllSubCompany();



            } else {
                this.GoToPage();
            }
        } catch (error) {
            this.GoToPage();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },

    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetails() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.company = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyDetailsByInfo() {
            try {
                const response = await this.$API.get(this.$GetCompanyDetails, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FullName = this.info.name;
                        this.Address = this.info.Address;
                        this.City = this.info.City;
                        this.CompanyTypeName = this.info.CompanyTypeName;
                        this.Country = this.info.Country;
                        this.Email = this.info.Email;
                        this.Fax = this.info.Fax;
                        this.CompanyIndustryType = this.info.IndustryType;
                        this.LogoPath = this.info.LogoPath;
                        this.PhoneNumber = this.info.PhoneNumber;
                        this.Postcode = this.info.Postcode;
                        this.RegistrationNumber = this.info.RegistrationNumber;
                        this.ShortName = this.info.ShortName;
                        this.State = this.info.State;

                        this.SetupSelectedOption();
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch company information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListCompanyType() {
            try {
                const response = await this.$API.get(this.$GetListCompanyType, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.companyType = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListIndustryType() {
            try {

                return this.$API
                    .get(this.$GetListIndustry, {
                        withCredentials: true,
                    })
                    .then((response) => {
                        if (response.status == 200) {
                            this.industryOptions = response.data;
                        }
                    });
            } catch (error) {
                console.log("errorIndustry" + error);
            }
        },
        async GetCountry() {
            try {
                const response = await this.$API.get(this.$GetCountry);
                if (response.status === 200) {
                    this.countryOptions = response.data;
                    this.SetupSelectedOption();
                } else {
                    console.error("Failed to fetch country information:", response);
                }
            } catch (error) {
                console.error("Error fetching country information:", error);
            }
        },
        async GetListState() {
            try {

                return this.$API
                    .get(this.$GetListState)
                    .then((response) => {
                        if (response.status == 200) {
                            this.stateOptions = response.data;

                            this.SetupSelectedOption(); // Ensure stateOptions are set before calling GetListCity
                            if (this.SelectedState && this.SelectedState.Id) {
                                this.GetListCity(this.SelectedState.Id);

                            }
                        }
                    });
            } catch (error) {
                console.log("errorState" + error);
            }
        },
        async GetListStateSub() {
            try {

                return this.$API
                    .get(this.$GetListState)
                    .then((response) => {
                        if (response.status == 200) {
                            this.stateOptions = response.data;
                            if (this.SelectedStateSub && this.SelectedStateSub.Id) {
                                this.GetListCitySub(this.SelectedStateSub.Id);
                                this.SetupSelectedOptionSub();
                            }
                            this.SetupSelectedOptionSub(); // Ensure stateOptions are set before calling GetListCity
                        }
                    });
            } catch (error) {
                console.log("errorState" + error);
            }
        },
        async GetListCity(stateId) {
            if (!stateId) {
                console.log("State ID is not defined");
                return;
            }
            try {
                const response = await this.$API.get(`${this.$GetListCity}?stateId=${stateId}`);
                if (response.status === 200) {
                    this.cityOptions = response.data;
                    console.log("Fetched cities:", this.cityOptions);
                    // Set default city based on company details
                    this.SelectedCity = _.find(this.cityOptions, { Name: this.company.City });
                    console.log("Selected city:", this.SelectedCity);
                }
            } catch (error) {
                console.log("Error fetching cities:", error);
            }
        },
        async GetCompanyBankDetails() {
            try {
                const response = await this.$API.get(this.$GetCompanyBanks, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.detailBank = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetCompanyBankDetailsByInfo() {
            try {
                const response = await this.$API.get(this.$GetCompanyBanks, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.BankAccountNumber = this.info.name;
                        this.BankName = this.info.BankName;
                        this.BbmbAutopayCode = this.info.BbmbAutopayCode;
                        this.CNumber = this.info.CNumber;
                        this.EmployerNumber = this.info.EmployerNumber;
                        this.EpfAccountNumber = this.info.EpfAccountNumber;
                        this.IncomeTaxNumber = this.info.IncomeTaxNumber;
                        this.OriginatorId = this.info.OriginatorId;
                        this.SocsoAccountNumber = this.info.SocsoAccountNumber;
                        this.ZakatNumber = this.info.ZakatNumber;

                        this.SetupSelectedOption();
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch company information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListBank() {
            try {
                const response = await this.$API.get(this.$GetListBanks, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.bank = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        SetupSelectedOption() {
            this.SelectedType = _.find(this.companyType, { Name: this.CompanyTypeName });
            this.SelectedIndustryType = _.find(this.industryOptions, { Name: this.CompanyIndustryType });
            this.SelectedCountry = _.find(this.countryOptions, { CountryName: this.Country });
            this.SelectedState = _.find(this.stateOptions, { Name: this.State });
            this.SelectedCity = _.find(this.cityOptions, { Name: this.City });

            this.SelectedBank = _.find(this.bank, { Name: this.BankName });


            console.log("SelectedCountry:", this.SelectedCountry);
            console.log("SelectedState:", this.SelectedState);
            console.log("SelectedCity:", this.SelectedCity);
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },

        closePopupAddSubs() {
            this.OpenAddSubsidary = false;
        },
        openAddSubs() {

                this.FullNameSub = "";
                this.ShortNameSub= '';
                this.RegistrationNumberSub= '';
                this.EmailSub= '';
                this.PhoneNumberSub= '';
                this.FaxSub= '';
                this.AddressSub = '';
                this.PostcodeSub = '';
            this.SelectedTypeSub = null;
            this.SelectedIndustryTypeSub = null;

            this.OpenAddSubsidary = true;


            

        },
        openExistCompany() {
            this.OpenLinkExistCompany = true;
        },
        openAddCompany() {
            this.OpenAddCompany = true;
        },
        openAddBank() {
            this.OpenAddBank = true;
        },
        closePopupExistCompany() {
            this.OpenLinkExistCompany = false;
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            this.selectedFile = file;
            if (file) {
                // Check if the uploaded file is an image
                if (file.type.startsWith('image/')) {
                    this.filePreview = URL.createObjectURL(file); // Create a URL for the image preview
                    this.fileName = null; // Clear the file name
                } else {
                    this.filePreview = null; // Clear the image preview
                    this.fileName = file.name; // Set the file name
                }
                this.submitFile();
            }
        },
        async submitFile(id) {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('id', id);

                try {
                    const response = await this.$API
                        .post(this.$UploadDocFile, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        SubmitCompany() {
            const formData = new FormData();

            formData.append("FullName", this.company.FullName);
            formData.append("ShortName", this.company.ShortName);
            formData.append("RegistrationNumber", this.company.RegistrationNumber);
            formData.append("TypeId", 1);
            formData.append("IndustryId", 14);
            formData.append("Email", this.company.Email);
            formData.append("PhoneNumber", this.company.PhoneNumber);
            formData.append("Address", this.company.Address);
            formData.append("Fax", this.company.Fax);
            formData.append("StateId", this.SelectedState.Id);
            formData.append("CityId", this.SelectedCity.Id);
            formData.append("Postcode", this.company.Postcode);
            formData.append("CountryId", this.SelectedCountry.Id);


            this.$API
                .post(this.$InsertStoreCompanyDetails, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        //this.submitFile(this.id);
                        this.isPopupSuccess = true;
                        this.GetCompanyDetails();


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async submitFile(id) {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('file', this.selectedFile);
                formData.append('id', this.user.id);

                try {
                    const response = await this.$API
                        .post(this.$UploadLogo, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });
                    console.log('Image uploaded successfully:', response.data);
                } catch (error) {
                    console.error('Error uploading image:', error);
                }
            } else {
                console.log('No file selected');
            }
        },
        closeSuccess() {
            this.isPopupSuccess = false;
            this.OpenAddCompany = false;
            window.location.reload();
        },
        closePopupAddCompany() {
            this.OpenAddCompany = false;
        },
        closePopupeAddBank() {
            this.OpenAddBank = false;
        },
        SubmitBank() {
            const formData = new FormData();

            formData.append("BankId", this.SelectedBank.Id);
            formData.append("BankAccountNumber", this.detailBank.BankAccountNumber);
            formData.append("BbmbAutopayCode", this.detailBank.BbmbAutopayCode);
            formData.append("EpfAccountNumber", this.detailBank.EpfAccountNumber);
            formData.append("SocsoAccountNumber", this.detailBank.SocsoAccountNumber);
            formData.append("IncomeTaxNumber", this.detailBank.IncomeTaxNumber);
            formData.append("EmployerNumber", this.detailBank.EmployerNumber);
            formData.append("LhdnBranch", this.detailBank.LhdnBranch);
            formData.append("OriginatorId", this.detailBank.OriginatorId);
            formData.append("ZakatNumber", this.detailBank.ZakatNumber);
            formData.append("CNumber", this.detailBank.CNumber);


            this.$API
                .post(this.$InsertStoreCompanyBank, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.OpenAddBank = false;
                        this.isPopupSuccess = true;

                        this.GetCompanyBankDetails();


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        SubmitSubsidary() {
            const formData = new FormData();

            formData.append("FullName", this.FullNameSub);
            formData.append("ShortName", this.ShortNameSub);
            formData.append("RegistrationNumber", this.RegistrationNumberSub);
            formData.append("TypeId", this.SelectedTypeSub.Id);
            formData.append("IndustryId", this.SelectedIndustryTypeSub.Id);
            formData.append("Email", this.EmailSub);
            formData.append("PhoneNumber", this.PhoneNumberSub);
            formData.append("Address", this.AddressSubs);
            formData.append("Fax", this.FaxSub);
            formData.append("StateId", this.SelectedStateSub.Id);
            formData.append("CityId", this.SelectedCitySub.Id);
            formData.append("Postcode", this.PostcodeSub);
            formData.append("CountryId", this.SelectedCountrySub.Id);
            formData.append("totalStaff", this.totalStaff);


            this.$API
                .post(this.$InsertStoreCompanySubsidary, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.OpenAddSubsidary = false;
                        this.isPopupSuccess = true;

                        this.GetSubCompanyDetails();


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        async GetAllSubCompany() {
            try {
                const response = await this.$API.get(this.$GetAllCompanySubsidary, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.sub = response.data;
                    this.filteredsubTableData = this.sub;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        openSubDetail(id) {
            this.OpenUpdateSubsidary = true;
            this.GetSubCompanyDetails(id);
            this.GetSubCompanyDetailsByInfo(id);
        },
        async GetSubCompanyDetails(id) {
            try {
                const response = await this.$API.get(this.$GetCompanySubsidaryDetails + "?id=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.subdetail = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetSubCompanyDetailsByInfo(id) {
            try {
                const response = await this.$API.get(this.$GetCompanySubsidaryDetails + "?id=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.FullNameSub = this.info.name;
                        this.AddressSub = this.info.Address;
                        this.CitySub = this.info.City;
                        this.CompanyTypeNameSub = this.info.CompanyTypeName;
                        this.CountrySub = this.info.Country;
                        this.EmailSub = this.info.Email;
                        this.FaxSub = this.info.Fax;
                        this.CompanyIndustryTypeSub = this.info.IndustryType;
                        this.PhoneNumberSub = this.info.PhoneNumber;
                        this.PostcodeSub = this.info.Postcode;
                        this.RegistrationNumberSub = this.info.RegistrationNumber;
                        this.ShortNameSub = this.info.ShortName;
                        this.StateSub = this.info.State;
                        this.SetupSelectedOptionSub();
                    }
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetListCitySub(stateId) {
            if (!stateId) {
                console.log("State ID is not defined");
                return;
            }
            console.log("Fetching cities for state ID:", stateId); // Add this line
            try {
                const response = await this.$API.get(`${this.$GetListCity}?stateId=${stateId}`);
                if (response.status === 200) {
                    this.cityOptionsSub = response.data;
                    console.log("Fetched cities:", this.cityOptionsSub); // Check this output
                    // Set default city based on company details
                    this.SelectedCitySubsidary = _.find(this.cityOptionsSub, { Name: this.subdetail.City });
                }
            } catch (error) {
                console.log("Error fetching cities:", error);
            }
        },
        async SetupSelectedOptionSub() {
            this.SelectedTypeSub = _.find(this.companyType, { Name: this.CompanyTypeNameSub });
            this.SelectedIndustryTypeSub = _.find(this.industryOptions, { Name: this.CompanyIndustryTypeSub });
            this.SelectedCountrySub = _.find(this.countryOptions, { CountryName: this.CountrySub });
            this.SelectedStateSub = _.find(this.stateOptions, { Name: this.StateSub });

            if (this.SelectedStateSub) {
                await this.GetListCitySub(this.SelectedStateSub.Id);
                this.SelectedCitySubsidary = _.find(this.cityOptionsSub, { Name: this.CitySub });
            }

            console.log("SelectedCountrySub:", this.SelectedCountrySub);
            console.log("SelectedStateSub:", this.SelectedStateSub);
            console.log("SelectedCitySub:", this.SelectedCitySubsidary);
        },

        UpdateSubsidary() {
            const formData = new FormData();

            formData.append("Id", this.subdetail.SubsidaryId);
            formData.append("FullName", this.subdetail.FullName);
            formData.append("ShortName", this.subdetail.ShortName);
            formData.append("RegistrationNumber", this.subdetail.RegistrationNumber);
            formData.append("TypeId", this.SelectedTypeSub.Id);
            formData.append("IndustryId", this.SelectedIndustryTypeSub.Id);
            formData.append("Email", this.subdetail.Email);
            formData.append("PhoneNumber", this.subdetail.PhoneNumber);
            formData.append("Address", this.subdetail.Address);
            formData.append("Fax", this.subdetail.Fax);
            formData.append("StateId", this.SelectedStateSub.Id);
            formData.append("CityId", this.SelectedCitySubsidary.Id);
            formData.append("Postcode", this.subdetail.Postcode);
            formData.append("CountryId", this.SelectedCountrySub.Id);
            formData.append("totalStaff", this.subdetail.TotalStaff);


            this.$API
                .post(this.$InsertStoreCompanySubsidary, formData, {
                    withCredentials: true,
                })
                .then((response) => {

                    if (response.status == 200) {

                        this.id = response.data;
                        this.OpenUpdateSubsidary = false;
                        this.isPopupSuccess = true;

                        this.GetSubCompanyDetails();
                  


                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closePopupUpdateSubs() {
            this.OpenUpdateSubsidary = false;          
        },
        GoToSetting()
        {
            this.$router.push("Setting");
        }



    }

};
</script>